import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export type RuleName =
  | "menu"
  | "menuList"
  | "menuItem"
  | "menuItemWithCheckbox"
  | "menuItemSelected"
  | "dropdownTitle"
  | "paper"

export const useStyles = makeStyles<void, RuleName>()(
  ({ spacing, shadows, palette }) => ({
    menu: {},
    paper: {
      minWidth: "160px",
      borderRadius: "2px",
      boxShadow: shadows[6]
    },
    menuList: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1)
    },
    menuItem: {
      padding: spacing(2, 4),
      minHeight: "auto",

      "&:hover, &:focus-visible": {
        backgroundColor: "#ECEEF1",
        color: palette.text.primary
      },

      "& .material-icons": {
        color: blueGrey[500]
      }
    },
    menuItemWithCheckbox: {
      padding: 0
    },
    menuItemSelected: {
      backgroundColor: lightBlue[50]
    },
    dropdownTitle: {
      color: blueGrey[500],
      paddingLeft: spacing(2)
    },
    menuListItemSubheader: {
      fontSize: "0.5875rem",
      textTransform: "uppercase",
      lineHeight: "2rem"
    },
    groupTitle: {
      padding: spacing(1, 3, 2),
      fontSize: "0.6875rem",
      lineHeight: "0.875rem",
      fontWeight: 500,
      color: blueGrey[700],
      cursor: "default"
    },
    groupDivider: {
      borderColor: blueGrey[100]
    }
  })
)
